export const userRoutes = [
    {
        path: '/',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./home'));
          reject(error);
        }),
      },
      {
        path: '/contact',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./contact'));
          reject(error);
        }),
      },
      {
        path: '/login',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./login'));
          reject(error);
        }),
      },
      {
        path: '/register',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./register'));
          reject(error);
        }),
      },
      {
        path: '/user/edit',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./editProfile'));
          reject(error);
        }),
      },
      {
        path: '/users/show/:profileId?',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./profile'));
          reject(error);
        }),
      },
      {
        path: '/become-a-host/:listId?/:formPage?',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./becomeHost'));
          reject(error);
        }),
      },
      {
        path: '/rooms/:listId/:preview?',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./viewListing'));
          reject(error);
        }),
      },
      {
        path: '/rooms',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./manageListing'));
          reject(error);
        }),
      },
      {
        path: '/s',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./search'));
          reject(error);
        }),
      },
      {
        path: '/user/verification',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./trustAndVerification'));
          reject(error);
        }),
      },
      {
        path: '/user/calendar',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./userCalendar'));
          reject(error);
        }),
      },
      {
        path: '/users/security',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./changePassword'));
          reject(error);
        }),
      },
      {
        path: '/dashboard',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./dashboard'));
          reject(error);
        }),
      },
      {
        path: '/inbox',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./inbox'));
          reject(error);
        }),
      },
      {
        path: '/message/:threadId/:type',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./viewMessage'));
          reject(error);
        }),
      },
      {
        path: '/book/:hostingId',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./book'));
          reject(error);
        }),
      },
      {
        path: '/user/payout',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./payout'));
          reject(error);
        }),
      },
      {
        path: '/user/addpayout',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./addPayout'));
          reject(error);
        }),
      },
      {
        path: '/payment/:reservationId',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./payment'));
          reject(error);
        }),
      },
      {
        path: '/users/trips/itinerary/:reservationId',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./itinerary'));
          reject(error);
        }),
      },
      {
        path: '/users/trips/receipt/:reservationId',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./receipt'));
          reject(error);
        }),
      },
      {
        path: '/reservation/:type',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./reservation'));
          reject(error);
        }),
      },
      {
        path: '/trips/:type',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./trips'));
          reject(error);
        }),
      },
      {
        path: '/user/transaction/:type?',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./transaction'));
          reject(error);
        }),
      },
      {
        path: '/warning',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./warning'));
          reject(error);
        }),
      },
      {
        path: '/cancel/:reservationId/:type',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./cancel'));
          reject(error);
        }),
      },
      {
        path: '/cancellation-policies/:type?',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./cancellationPolicies'));
          reject(error);
        }),
      },
      {
        path: '/user/reviews/:type?',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./reviews'));
          reject(error);
        }),
      },
      {
        path: '/review/write/:reservationId',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./writeReview'));
          reject(error);
        }),
      },
      {
        path: '/password/verification',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./passwordVerification'));
          reject(error);
        }),
      },
      {
        path: '/userbanned',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./userbanned'));
          reject(error);
        }),
      },
      {
        path: '/user/payout/failure',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./addPayoutFailure'));
          reject(error);
        }),
      },
      {
        path: '/document-verification',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./documentVerification'));
          reject(error);
        }),
      },
      {
        path: '/page/:u1?',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./blog'));
          reject(error);
        }),
      },
      {
        path: '/about',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./static/about'));
          reject(error);
        }),
      },
      {
        path: '/privacy',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./static/privacy'));
          reject(error);
        }),
      },
      {
        path: '/help',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./static/help'));
          reject(error);
        }),
      },
      {
        path: '/safety',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./static/trustAndSafety'));
          reject(error);
        }),
      },
      {
        path: '/travel',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./static/travelCredit'));
          reject(error);
        }),
      },
      {
        path: '/whyhost',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./whyhostnew'));
          reject(error);
        }),
      },
      {
        path: '/cookie-policy',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./static/cookiePolicy'));
          reject(error);
        }),
      },
      {
        path: '/wishlists/:id?',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./wishLists'));
          reject(error);
        }),
      },
      {
        path: '/users/delete-user',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./deleteUser'));
          reject(error);
        }),
      },
      {
        path: '/terms-of-service',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./static/termsOfService'));
          reject(error);
        }),
      }
];